import { AnalystCount, BasketMonthlyStat, BasketStats } from '@domain';
import {
	DirectDealBasketsRequest,
	DirectDealBasketsResponse,
	DirectDealOverview,
	PackConversionDailyStat,
	ReportDirectDealSummary,
} from '@services/marketBasketReports.types'

import api from '.'


// Query Key factory
export const MarketBasketReportsKeys = {
	basketMonthlyAverageStats: ['basket-monthly-average-stats'],
	basketStats: ({ dateRangeStart, dateRangeEnd }) => [
		'basket-stats',
		{ dateRangeStart, dateRangeEnd },
	],
	countsPerAnalyst: ['counts-per-analyst'],
	directDealBaskets: (query: DirectDealBasketsRequest) => ['direct-deal-baskets', query],
	directDealDetail: ['direct-deal-detail'],
	directDealOverview: ({ dateRangeStart, dateRangeEnd }) => [
		'direct-deal-overview',
		{ dateRangeStart, dateRangeEnd },
	],
	directDeals: ['direct-deals'],
	monthlyBasketsCreated: ['monthly-baskets-created'],
	monthlyProcessingTime: ['monthly-processing-time'],
	monthlyTotalMatches: ['monthly-total-matches'],
	monthlyTotalSavings: ['monthly-total-annual-savings'],
	monthlyTotalSpend: ['monthly-total-spend'],
	packConversions: ({ dateRangeStart, dateRangeEnd }) => [
		'pack-conversions',
		{ dateRangeStart, dateRangeEnd },
	],
}

const MarketBasketReportsApi = {
	basketStats: ({ dateRangeStart, dateRangeEnd }) =>
		api
			.get<APIRes<BasketStats[]>>('/market-baskets/reports/basket-stats', {
				params: { dateRangeStart, dateRangeEnd },
			})
			.then((res) => res.data.data),
	countsPerAnalyst: () =>
		api
			.get<APIRes<AnalystCount[]>>('/market-baskets/reports/weekly-count-per-analyst')
			.then((res) => res.data.data),
	directDealBaskets: (query: DirectDealBasketsRequest) =>
		api
			.get<APIRes<DirectDealBasketsResponse>>('/market-baskets/reports/direct-deals/baskets', {
				params: query,
			})
			.then((res) => res.data.data),
	directDealOverview: ({ dateRangeStart, dateRangeEnd }) =>
		api
			.get<APIRes<DirectDealOverview>>('/market-baskets/reports/direct-deals/overview', {
				params: { dateRangeStart, dateRangeEnd },
			})
			.then((res) => res.data.data),
	directDeals: () =>
		api
			.get<APIRes<ReportDirectDealSummary[]>>(`/market-baskets/reports/direct-deals`)
			.then((res) => res.data.data),
	monthlyAverageStats: () =>
		api
			.get<APIRes<BasketMonthlyStat[]>>('/market-baskets/reports/six-mon-average-time')
			.then((res) => res.data.data),
	monthlyBasketsCreated: () =>
		api
			.get<APIRes<number>>('/market-baskets/reports/monthly-baskets-created')
			.then((res) => res.data.data),
	monthlyTotalSpend: () =>
		api
			.get<APIRes<number>>('/market-baskets/reports/monthly-total-spend')
			.then((res) => res.data.data),
	monthlyTotalMatches: () =>
		api
			.get<APIRes<number>>('/market-baskets/reports/monthly-total-matches')
			.then((res) => res.data.data),
	monthlyTotalSavings: () =>
		api
			.get<APIRes<number>>('/market-baskets/reports/monthly-total-annual-savings')
			.then((res) => res.data.data),
	packConversions: ({ dateRangeStart, dateRangeEnd }) =>
		api
			.get<APIRes<PackConversionDailyStat[]>>('/market-baskets/reports/pack-conversions', {
				params: { dateRangeStart, dateRangeEnd },
			})
			.then((res) => res.data.data),
}

export default MarketBasketReportsApi
